import React from 'react';
import {
    ConversationContext,
    ConversationParticipantRole,
    JobApplicationEvent,
    ResumeContactEvent,
    useConversation,
} from '@indeed/messaging-react';
import { getResumeURL } from '../../../browser-store/utils/paths';

interface ConversationBeginEventContainerProps {
    conversationId: string;
}

const ConversationBeginEventContainer: React.FC<ConversationBeginEventContainerProps> = ({
    conversationId,
}) => {
    const { data } = useConversation(conversationId);
    const conversation = data?.conversation;

    if (conversation?.context === ConversationContext.ResumeContact) {
        const recruiterParticipant = conversation.participants?.find(
            (participant) =>
                participant.role === ConversationParticipantRole.Employer && !participant.removed
        );
        const recruiterName = recruiterParticipant?.participantName ?? undefined;

        return <ResumeContactEvent recruiterName={recruiterName} profileUrl={getResumeURL()} />;
    }

    return <JobApplicationEvent conversationId={conversationId} />;
};

export default ConversationBeginEventContainer;
